import { render } from "./FormModal.vue?vue&type=template&id=0e79fbf2"
import script from "./FormModal.vue?vue&type=script&lang=ts"
export * from "./FormModal.vue?vue&type=script&lang=ts"
script.render = render

export default script